import { TEquipmentTypesSchema } from 'transfix-form/forms/CarrierFleetInformation/components/EquipmentTypesModal/schema/EquipmentTypesSchema'
import { IUpdateMotorCarrierEquipmentCapabilityInput } from 'types/FMSGraphqlTypes'
import { IFleetInfoFragment } from '../graphql/FleetInfoFragment'

export const getUpdateMotorCarrierEquipmentCapabilityInput = ({
  formValues,
  motorCarrierId,
}: {
  motorCarrierId: IFleetInfoFragment['id']
  formValues: TEquipmentTypesSchema
}): IUpdateMotorCarrierEquipmentCapabilityInput => {
  const { isDryVanCapable, isFlatbedCapable, isReeferCapable, powerUnitCount, trailerCount } =
    formValues || {}
  return {
    motorCarrierId,
    powerUnitCount: powerUnitCount || 0,
    trailerCount: trailerCount || 0,
    isReeferCapable,
    isDryVanCapable,
    isFlatbedCapable,
  }
}
